import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Swal from 'sweetalert2';
import baseURL from '../../url';

import './ProductosInventarioData.css';

export default function ProductosInventarioData() {

    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);

    const [modalVisible, setModalVisible] = useState(false);
    const [modo, setModo] = useState('create');
    const [producto, setProducto] = useState(null);

    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [stock, setStock] = useState('');
    const [idCategoriaInventario, setIdCategoriaInventario] = useState('');

    const [imagen, setImagen] = useState(null);
    const [preview, setPreview] = useState(null);
    const [idEdit, setIdEdit] = useState(null);

    useEffect(() => {
        cargarProductos();
        cargarCategorias();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosinventarioget.php`)
            .then(res => res.json())
            .then(data => setProductos(data?.productos || []))
            .catch(() => toast.error("Error al cargar productos"));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasinventarioget.php`)
            .then(res => res.json())
            .then(data => setCategorias(data?.categorias || []))
            .catch(() => toast.error("Error al cargar categorías"));
    };

    const crearProducto = async () => {

        const formData = new FormData();
        formData.append('codigo', '');
        formData.append('nombre', nombre.trim());
        formData.append('marca', '');
        formData.append('idCategoriaInventario', idCategoriaInventario);
        formData.append('stock', stock);
        formData.append('costo', 0);
        formData.append('estadoProducto', 'Disponible');

        if (imagen) formData.append('imagen', imagen);

        try {
            const res = await fetch(`${baseURL}/productosinventariopost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await res.json();

            if (data?.error) return Swal.fire('Error', data.error, 'error');

            Swal.fire('OK', 'Producto creado', 'success');
            cerrarModal();
            cargarProductos();

        } catch {
            toast.error("Error al crear producto");
        }
    };

    const actualizarProducto = async (id) => {

        const payload = {
            idProductoInventario: id,
            codigo: '',
            nombre: nombre.trim(),
            marca: '',
            stock,
            costo: 0,
            estadoProducto: 'Disponible',
            idCategoriaInventario
        };

        try {

            const res = await fetch(
                `${baseURL}/productosinventariotextput.php`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                }
            );

            const text = await res.text();

            let data;

            try {
                data = JSON.parse(text);
            }
            catch {
                console.error("No es JSON válido");
                return;
            }


            if (data?.error) {

                Swal.fire(
                    'Error',
                    data.error,
                    'error'
                );

                return;
            }

            // actualizar imagen si se seleccionó una nueva

            if (imagen) {

                const formData = new FormData();

                formData.append(
                    'idProductoInventario',
                    id
                );

                formData.append(
                    'imagen',
                    imagen
                );

                const resImagen = await fetch(
                    `${baseURL}/productosinventarioimageput.php`,
                    {
                        method: 'POST',
                        body: formData
                    }
                );

                const dataImagen =
                    await resImagen.json();

                if (dataImagen?.error) {

                    Swal.fire(
                        'Error',
                        dataImagen.error,
                        'error'
                    );

                    return;
                }
            }

            Swal.fire(
                'OK',
                'Producto actualizado',
                'success'
            );

            cerrarModal();
            cargarProductos();
        }
        catch (err) {

            console.error(err);

            toast.error(
                "Error al actualizar"
            );
        }
    };

    const eliminar = (id) => {

        Swal.fire({
            title: '¿Eliminar producto?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar'
        }).then((r) => {

            if (!r.isConfirmed) return;

            fetch(`${baseURL}/productosinventariodelete.php`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idProductoInventario: id
                })
            })
                .then(res => res.json())
                .then(() => {
                    toast.success("Producto eliminado");
                    cargarProductos();
                })
                .catch(() => toast.error("Error al eliminar"));
        });
    };

    const abrirModalCrear = () => {
        setModo('create');
        setProducto(null);

        setNombre('');
        setDescripcion('');
        setStock('');
        setIdCategoriaInventario('');
        setImagen(null);
        setPreview(null);

        setModalVisible(true);
    };

    const abrirModalEditar = (item) => {
        setModo('edit');
        setProducto(item);

        setNombre(item.nombre || '');
        setDescripcion(item.descripcion || '');
        setStock(item.stock || '');
        setIdCategoriaInventario(item.idCategoriaInventario || '');

        setImagen(null);
        setPreview(item.imagen || null);

        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setProducto(null);
        setIdEdit(null); // 👈 IMPORTANTE
    };

    return (
        <div className="productosInventario">

            <ToastContainer />

            {/* HEADER */}
            <div className="header-actions">
                <button className="nuevo" onClick={abrirModalCrear}>
                    <FontAwesomeIcon icon={faPlus} />
                    Agregar Producto
                </button>
            </div>

            {/* TABLA */}
            <div className="table-container">
                <div className="table">

                    {/* HEADER COLUMNAS */}
                    <div className="tableHeader">
                        <div>Imagen</div>
                        <div>Nombre</div>
                        <div>Categoría</div>
                        <div>Stock</div>
                        <div>Acciones</div>
                    </div>

                    <div id="tbody">

                        {productos.map(item => (
                            <div key={item.idProductoInventario} className="rowTable">

                                <div className="imgCell">
                                    {item.imagen ? (
                                        <img src={item.imagen} alt="producto" />
                                    ) : (
                                        <span>Sin imagen</span>
                                    )}
                                </div>

                                <div>{item.nombre}</div>
                                <div>{item.categoria}</div>
                                <div>{item.stock}</div>

                                <div className="tdFlex">
                                    <button className="editar" onClick={() => abrirModalEditar(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>

                                    <button className="eliminar" onClick={() => eliminar(item.idProductoInventario)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </div>

                            </div>
                        ))}

                    </div>
                </div>
            </div>

            {/* MODAL AISLADO */}
            {modalVisible && (
                <div className="productosInventarioModalOverlay">

                    <div className="productosInventarioModalCard">

                        <span className="close" onClick={cerrarModal}>&times;</span>

                        <h3>{modo === 'create' ? 'Nuevo producto' : 'Editar producto'}</h3>

                        <input placeholder="Nombre" value={nombre} onChange={e => setNombre(e.target.value)} />
                        <input placeholder="Descripción" value={descripcion} onChange={e => setDescripcion(e.target.value)} />
                        <input type="number" placeholder="Stock" value={stock} onChange={e => setStock(e.target.value)} />

                        <select value={idCategoriaInventario} onChange={e => setIdCategoriaInventario(e.target.value)}>
                            <option value="">Categoría</option>
                            {categorias.map(cat => (
                                <option key={cat.idCategoriaInventario} value={cat.idCategoriaInventario}>
                                    {cat.categoria}
                                </option>
                            ))}
                        </select>

                        <input
                            type="file"
                            accept="image/*"
                            onChange={e => {
                                setImagen(e.target.files[0]);
                                setPreview(URL.createObjectURL(e.target.files[0]));
                            }}
                        />

                        {preview && (
                            <img src={preview} style={{ width: 80, borderRadius: 6 }} />
                        )}

                        <div className="modalFooter">
                            <button className="btnCancelar" onClick={cerrarModal}>
                                Cancelar
                            </button>

                            <button
                                className="btnGuardar"
                                onClick={() =>
                                    modo === 'create'
                                        ? crearProducto()
                                        : actualizarProducto(producto?.idProductoInventario)
                                }
                            >
                                Guardar
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </div>
    );
}